import React from 'react'
import { inject, observer } from 'mobx-react'
import Modal from '../../../generic/Modal'
import RPSTable from './RPSTable'

const RPSModal = inject('nfsStore')(observer(props => {
  const { nfsStore } = props
  const { rpsModal } = nfsStore.state
  const modalOptions = []
  return (
    <Modal 
      isActive={rpsModal.isActive} 
      onClose={() => nfsStore.closeRpsModal()} 
      title='Arquivos do Lote RPS' 
      options={modalOptions}
    >
      <RPSTable />
    </Modal>
  )
}))

export default RPSModal



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4nfs/RPSModal.js